    angular.module('assets', ['core', 'dictionary'])
        .factory('Asset', function ($resource) {
            return $resource('/crm/api/asset/:id', {}, {
                list: {method: 'GET', isArray: false},
                get: {method: 'GET'},
                update: {method: 'PUT', params: {id: "@id"}},
                remove: {method: 'DELETE'},
                storage: {method: 'GET', url: '/crm/api/asset-storage/:id/storage', params: {id: "@id"}, isArray: true},
                listWithProjectCount: {method: 'GET', url: '/crm/api/asset-list'},
                autocomplete: {method: 'GET', isArray: true, url: '/crm/api/asset/autocomplete'},
                isSupervisor: {method: 'GET', url: '/crm/api/settings/asset/supervisor-check'}
            });
        })
        .service('AssetService', function ($rootScope, modals, Asset, ModuleSettings) {
            this.addModal = () => {
                let entity = {
                    id: null,
                    stockManagementType: "STOCK"
                };
                return editModal(entity);
            };
            this.edit = id => {
                Asset.get({id: id}).$promise.then(entity => editModal(entity));
            };
            this.show = id => {
                Asset.get({id: id}).$promise.then(entity => modals.open('app/asset/show-modal.html', 'AssetShowController', entity, {size: 'lg'}, "$ctrl"));
            };
            this.remove = item => {
                return modals.confirmDelete(item.name, () => Asset.delete({id: item.id}).$promise.then(() => $rootScope.$broadcast('asset.updated')));
            };
            this.settingsModal = () => {
                ModuleSettings.get({module: "asset"}).$promise.then(settings => modals.open('app/asset/settings-modal.html', 'AssetSettingsController', settings, {size: 'md'}, "$ctrl"));
            };

            function editModal(entity) {
                return modals.open('app/asset/edit-modal.html', 'AssetDialogController', entity, {size: 'lg'}, "$ctrl")
            }
        })
        .directive('assetSettingsSupervisorCheck', function (AssetSettingsLoader) {
            return {
                restrict: 'A',
                link: function (scope, element, attrs) {

                    var setVisible = function () {
                            element.removeClass('hidden');
                        },
                        setHidden = function () {
                            element.addClass('hidden');
                        },
                        reloadSupervisorCheck = function (force) {
                            if (force) {
                                AssetSettingsLoader.isSupervisor().then(function (isSupervisor) {
                                    if (isSupervisor === true) {
                                        setVisible()
                                    } else {
                                        setHidden();
                                    }
                                })
                            }
                            setHidden();
                        };


                    reloadSupervisorCheck();

                    scope.$watch(function () {
                        return AssetSettingsLoader.isSupervisorResolved();
                    }, function () {
                        reloadSupervisorCheck(true);
                    });

                }
            };
        })
        .run(function (NavbarLeftMenu) {
            NavbarLeftMenu.add({
                authorities: "ROLE_ASSETS",
                path: "/asset",
                ico: "fa fa-fw fa-gears",
                name: 'asset.menu',
                order: 86
            });
        })
        .config(function ($stateProvider) {
            $stateProvider.state('asset', {
                parent: 'app',
                data: {
                    authorities: ['ROLE_USER', "ROLE_ASSETS"]
                }
            });
            $stateProvider.state('assetList', {
                parent: 'asset',
                url: '/asset?{page:int}&{size:int}&sort&search&condition&acquisition&{brand:int}&{group:int}&{projectStorage:boolean}',
                views: {
                    'content@': 'assetListComponent'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Asset, $q, $stateParams) => Asset.list(angular.copy($stateParams)).$promise
                }
            });
            $stateProvider.state('assetProjectList', {
                parent: 'asset',
                url: '/asset-project?{page:int}&{size:int}&sort&search&condition&acquisition&brand&group&project&{projectStorage:boolean}',
                params: {
                    projectStorage: true,
                    project: { array: true, type: "int" },
                },
                views: {
                    'content@': 'assetProjectListComponent'
                },
                resolve: {
                    filters: $stateParams => angular.copy($stateParams),
                    page: (Asset, $q, $stateParams) => Asset.list(angular.copy($stateParams)).$promise
                }
            });
        });
